import { useEffect, useRef, useState } from 'react';
export function useRaceState(initialState) {
    const [state, setState] = useState(initialState);
    const { current } = useRef({
        isMounted: false,
        counter: 0,
        setState: () => {
            current.counter = (current.counter + 1) % Number.MAX_SAFE_INTEGER;
            const id = current.counter;
            return (dispatch) => {
                if (current.isMounted && current.counter === id)
                    setState(dispatch);
            };
        },
    });
    useEffect(() => {
        current.isMounted = true;
        return () => void (current.isMounted = false);
    });
    return [state, current.setState];
}
//# sourceMappingURL=useRaceState.js.map